import { CommitmentSourcesService_commitmentSourcesServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentSourcesService_commitmentSourcesServiceGetEntity'

export const useFetchCommitmentSources =
  CommitmentSourcesService_commitmentSourcesServiceGetEntity.useSuspenseQuery
